<template>
    <div class="Account">
        <div class="container">
            <div class="row">
                <div class="col-12 profil-vermieter">

                    <!-- Card -->
                    <div class="card card-cascade cascading-admin-card user-card my-5">

                        <!-- Card Data -->
                        <div class="admin-up d-flex justify-content-start p-3">
                            <h1 class="font-weight-bold mb-0">{{$t('Global.Profil')}}</h1>
                        </div>
                        <!-- Card Data -->

                        <!-- Card content -->
                        <div class="card-body card-body-cascade">


                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Vorname')" v-model="user.vorname" />

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Nachname')" v-model="user.nachname" />

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Straße')" v-model="user.strasse" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.PLZ')" v-model="user.plz" />

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Stadt')" v-model="user.ort" />
                                </div>

                            </div>
                            <div class="row ">
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Telefon')" v-model="user.telefon" />

                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Mobil')" v-model="user.mobil" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Vermieter.Fax')" v-model="user.fax" />

                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <mdb-input :label="$t('Mieter.Email')" v-model="user.accountidentifier" />
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input type="password" :label="$t('Mieter.Password')" v-model="newPassword" autocomplete="off"/>
                                </div>
                                <div class="col-12 col-md-4">
                                    <mdb-input type="password" :label="$t('Mieter.Passwordconfirm')" v-model="newPasswordvalid" autocomplete="off"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-space-between flex-column flex-lg-row">
                                        <mdb-btn color="danger" v-on:click="confirmDelete()">{{$t('Global.Deleteaccount')}}</mdb-btn>
                                        <mdb-btn color="primary"  @click.native.prevent="saveUserVermieter()">{{$t('Global.Speichern')}}</mdb-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Card content -->

                    </div>
                    <!-- Card -->

                </div>
            </div>
        </div>
        <div class="confirm__remove" v-bind:class="{active: confirm == true}">
            <div class="inner d-flex justify-content-center align-items-center flex-column">
                <h2 class="text-center">Sind Sie sicher, dass Sie Ihren Account löschen möchten?</h2>

                <div class="d-flex mt-5">
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(true)">löschen</div>
                    <div class="btn btn-outline-danger" v-on:click="confirmRemove(false)">abbrechen</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mdbBtn, mdbInput, mdbDatePicker, mdbSelect } from 'mdbvue';
    import settings from '@/components/Settings.json';
   import { authComputed } from '@/helpers/helper.js';
   import UserService from "../../services/UserService";
    import format from 'date-fns/format'
    export default {
        name: "Profil",
        components: {
            mdbBtn,
            mdbInput,
            mdbDatePicker,
            mdbSelect

        },
        props: {
        },
        data() {
            return {
                user: Object,
                newPassword: "",
                newPasswordvalid: "",
                confirm: false,
            };
        },
        methods: {
            confirmDelete(){
                this.confirm = true;
            },
            confirmRemove(state){
                if(state){
                    this.confirm = false;
                    this.deleteUser();
                } else {
                    this.confirm = false;
                }
            },
            deleteUser(){
                UserService.deleteUserVermieter(this.user.account, this.user.persistence_object_identifier).then(response => {
                    this.$store.dispatch("logout")
                        .then(() => this.$router.push("/login"))
                        .catch(err => console.log(err));
                    console.log(response);
                })
                    .catch(e => {
                        this.$notify.warn({
                            message: "Ihr Account konnte nicht gelöscht werden!",
                            position: 'top right',
                            timeOut: 4000
                        });
                    });
            },
            saveUserVermieter(){
                if(this.newPassword != ""){
                    if( this.newPassword === this.newPasswordvalid){
                        this.user.credentialssource = this.newPassword;

                        UserService.editUserVermieter(this.user).then(response => {
                            this.$store.dispatch("updateUser", this.user)
                            this.$notify.success({
                                message: "Ihr Account wurde aktualisiert!",
                                position: 'top right',
                                timeOut: 4000
                            });
                        })
                            .catch(e => {
                                this.$notify.warn({
                                    message: "Ihr Account konnte nicht aktualisiert werden!",
                                    position: 'top right',
                                    timeOut: 4000
                                });
                                console.log(e);

                            });

                    } else {
                        this.$notify.error({
                            message: "Passwörter stimmen nicht überein!",
                            position: 'top right',
                            timeOut: 4000
                        });
                    }
                } else {
                    UserService.editUserVermieter(this.user).then(response => {
                        this.$store.dispatch("updateUser", this.user)
                        this.$notify.success({
                            message: "Ihr Account wurde aktualisiert!",
                            position: 'top right',
                            timeOut: 4000
                        });
                    })
                        .catch(e => {
                            this.$notify.warn({
                                message: "Ihr Account konnte nicht aktualisiert werden!",
                                position: 'top right',
                                timeOut: 4000
                            });
                            console.log(e);

                        });
                    }
                }

        },
        mounted: function() {
            let storeUser = _.clone(this.$store.getters.userObject);
            let getUser = storeUser;
                if(typeof(getUser) === "string" || getUser instanceof String){
                    let u =  JSON.parse(getUser);
                     this.user = u;

                } else {
                     this.user = getUser;
                }

        },
        beforeRouteLeave (to, from , next) {
            console.log("next");
            console.log(this.user);

            let getUser = this.$store.getters.userObject;
            if(typeof(getUser) === "string" || getUser instanceof String){
                let user =  JSON.parse(getUser);
                this.user = user;
            } else {
                this.user = getUser;
            }
            next();
        }
    };
</script>
